import React from "react";
import PropTypes from "prop-types";
import { pure } from "recompose";
import { ArrowDropDownIconNoFill, PersonIcon } from "../../theme/assets";
import classnames from "classnames";
import styles from "./BookingFormSummary.scss";

function Separator() {
  return (
    <div className={classnames("wbkv9-BookingFormSummary-Separator", styles.Separator)}>&#183;</div>
  );
}

function Element({ children, lastOne }) {
  return (
    <div className={classnames("wbkv9-BookingFormSummary-Element", styles.Element)}>
      {children}
      {!lastOne && <Separator />}
    </div>
  );
}

const parts = ["destination", "dates", "occupants"];

function DestinationPart({ text }) {
  return (
    <div className={classnames("wbkv9-BookingFormSummary-DestinationPart", styles.DestinationPart)}>
      {text}
    </div>
  );
}
function DatesPart({ text }) {
  return (
    <div className={classnames("wbkv9-BookingFormSummary-DatesPart", styles.DatesPart)}>{text}</div>
  );
}

function OccupantsPart({ text }) {
  if (!text) {
    return null;
  }

  return (
    <div className={classnames("wbkv9-BookingFormSummary-OccupantsPart", styles.OccupantsPart)}>
      <div>{text}</div>

      <div>
        <PersonIcon />
      </div>
    </div>
  );
}

function PartRenderer({ type, info, lastOne }) {
  let Elem = null;

  switch (type) {
    case "destination":
      Elem = <DestinationPart text={info[type]} lastOne={lastOne} />;
      break;

    case "dates":
      Elem = <DatesPart text={info[type]} lastOne={lastOne} />;
      break;

    case "occupants":
      Elem = <OccupantsPart text={info[type]} lastOne={lastOne} />;
      break;

    default:
      break;
  }

  return Elem;
}
function BookingFormSummary({ info, onClick, hasFilters }) {
  let lastIdx = parts.length - 1;

  return (
    <div
      onClick={onClick}
      className={classnames(
        "wbkv9-BookingFormSummary-Wrapper",
        styles.BookingFormSummary,
        hasFilters && styles.hasFilters
      )}>
      <div
        className={classnames(
          "wbkv9-BookingFormSummary-Container",
          styles.BookingFormSummaryContainer
        )}>
        <div className={classnames("wbkv9-BookingFormSummary-Summary", styles.summary)}>
          {parts.map((part, idx) => {
            if (!info[part]) {
              --lastIdx;
              return null;
            }

            return (
              <Element key={part} lastOne={idx === lastIdx}>
                <PartRenderer type={part} info={info} />
              </Element>
            );
          })}
        </div>
        <button
          className={classnames("wbkv9-BookingFormSummary-ExpandControl", styles.expandControl)}>
          <ArrowDropDownIconNoFill />
        </button>
      </div>
    </div>
  );
}

BookingFormSummary.propTypes = {
  info: PropTypes.object.isRequired,
  onClick: PropTypes.func,
};

export default pure(BookingFormSummary);
